import { render, staticRenderFns } from "./ServicedPlots.vue?vue&type=template&id=e298e0d0&scoped=true&"
import script from "./ServicedPlots.vue?vue&type=script&lang=js&"
export * from "./ServicedPlots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e298e0d0",
  null
  
)

export default component.exports